const CHUNK_RELOAD_KEY = "mente-sa-chunk-reload";
const CACHE_BUST_PARAM = "__app_refresh";
const RELOAD_COOLDOWN_MS = 30_000;

const CHUNK_ERROR_PATTERN =
  /Failed to fetch dynamically imported module|Loading chunk|Loading CSS chunk|Importing a module script failed|error loading dynamically imported module|módulo da aplicação não foi carregado corretamente|Cannot read properties of undefined \(reading ['"]default['"]\)/i;

export function isChunkLoadError(error: unknown): boolean {
  const message =
    error instanceof Error
      ? error.message
      : typeof error === "string"
        ? error
        : "";

  return CHUNK_ERROR_PATTERN.test(message);
}

export function reloadWithFreshAssets(): boolean {
  if (!navigator.onLine) return false;

  const now = Date.now();
  const previousReload = Number(sessionStorage.getItem(CHUNK_RELOAD_KEY) || 0);
  if (now - previousReload < RELOAD_COOLDOWN_MS) return false;

  sessionStorage.setItem(CHUNK_RELOAD_KEY, String(now));
  const url = new URL(window.location.href);
  url.searchParams.set(CACHE_BUST_PARAM, String(now));
  window.location.replace(url.toString());
  return true;
}

export function installChunkRecovery(): void {
  // O projeto já não utiliza service worker. Remove versões antigas que ainda
  // possam intercetar pedidos e devolver chunks eliminados após uma publicação.
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      registrations.forEach((registration) => registration.unregister());
    }).catch(() => undefined);
  }

  if ("caches" in window) {
    caches.keys().then((keys) => {
      keys.forEach((key) => caches.delete(key));
    }).catch(() => undefined);
  }

  window.addEventListener("vite:preloadError", (event) => {
    // Não chamar preventDefault: isso faria o import() resolver como undefined
    // e o React falharia depois ao tentar ler a propriedade `default`.
    reloadWithFreshAssets();
  });

  window.addEventListener("error", (event) => {
    if (isChunkLoadError(event.error || event.message)) {
      reloadWithFreshAssets();
    }
  });

  window.addEventListener("unhandledrejection", (event) => {
    if (isChunkLoadError(event.reason)) {
      reloadWithFreshAssets();
    }
  });
}